import React,{useId,useLayoutEffect,useRef,useState} from 'react';

// Clamp the original text by rendered height; short text gets no extra control.
export default function ExpandableText({text,label,lines=4,className='',expanded,onExpanded}){
 const id=useId(),content=useRef(null),container=useRef(null);
 const [long,setLong]=useState(false);
 useLayoutEffect(()=>{
  const el=content.current;if(!el)return;
  const measure=()=>setLong(el.scrollHeight>parseFloat(getComputedStyle(el).lineHeight)*lines+2);
  measure();const observer=new ResizeObserver(measure);observer.observe(el);return()=>observer.disconnect();
 },[text,lines]);
 function toggle(){
  const box=container.current,scroller=box.closest('.translation-panel-scroll');
  const top=box.getBoundingClientRect().top,edge=scroller?.getBoundingClientRect().top;
  onExpanded(!expanded);
  if(expanded)requestAnimationFrame(()=>{if(scroller&&top<edge)scroller.scrollTop+=box.getBoundingClientRect().top-edge-12;box.querySelector('button')?.focus({preventScroll:true});});
 }
 const control=<button type="button" className="poll-text-toggle" aria-expanded={Boolean(expanded)} aria-controls={id} onClick={toggle}>{expanded?'收合'+label:'展開'+label}</button>;
 return <div ref={container} className={'poll-expandable '+className} style={{'--preview-lines':lines}}>{long&&expanded&&control}<p id={id} ref={content} className={expanded?'':'poll-text-clamped'}>{text}</p>{long&&control}</div>;
}
